document.addEventListener('DOMContentLoaded', () => {
  const btns = document.querySelectorAll('.js-close-window-btn');
  if (btns.length === 0) return;

  btns.forEach(elem => {
    elem.addEventListener('click', () => window.close());
  });
});
